"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactAddress = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_entity_1 = require("./contact.entity");
const address_entity_1 = require("./address.entity");
let ContactAddress = class ContactAddress {
    constructor(contact, address) {
        this.contact = contact;
        this.address = address;
    }
};
exports.ContactAddress = ContactAddress;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ContactAddress.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], ContactAddress.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], ContactAddress.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.id, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactAddress.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.id, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactAddress.prototype, "address", void 0);
exports.ContactAddress = ContactAddress = tslib_1.__decorate([
    (0, typeorm_1.Entity)("contact_address"),
    tslib_1.__metadata("design:paramtypes", [Object, Object])
], ContactAddress);
